import React from 'react';
import Link from 'next/link';
import { gql } from '@soundxyz/gql-string';
import { ListContent } from '@components/Feed/ListViews/components/ListContent';
import { FeedListViewContainer } from '@components/Feed/ListViews/components/shared';
import { Avatar } from '@components/basics/Images/Avatar';
import { VerifiedRainbow } from '@components/icons/VerifiedRainbow';
import { MediaQuery } from '@context/mediaQuery';
import {
  type FragmentType,
  getFragment,
  ReleaseActivityReleasePostedFragmentDoc,
} from '@graphql/reactQuery';
import { trackClickEvent } from '@lib/analytics';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleaseActivityReleasePosted on CreatedPost {
    id
    post {
      id
      content
      createdAt
      creator {
        publicAddress
        username
        webappUri
        avatar {
          id
          url
        }
        artist {
          id
        }
      }
      webappUri
    }
  }
`);

export function ReleaseActivityReleasePosted({
  createdPostFrag,
}: {
  createdPostFrag: FragmentType<ReleaseActivityReleasePostedFragmentDoc>;
}) {
  const { post } = getFragment(ReleaseActivityReleasePostedFragmentDoc, createdPostFrag);
  const { tablet } = MediaQuery.useContainer();
  return (
    <FeedListViewContainer>
      <div className="w-full">
        <Link
          href={webappUriPath(post.webappUri)}
          onClick={() => {
            trackClickEvent({
              event: 'Post Link Clicked',
              properties: {
                associationId: post.id,
                associationType: 'Post',
                sourceComponent: 'Release Activity Feed',
              },
            });
          }}
        >
          <ListContent isoDateString={post.createdAt}>
            <div className="flex items-center gap-2">
              <Avatar
                className="flex-00auto"
                disableLink
                size={tablet ? 48 : 40}
                borderRadius={999}
                walletAddress={post.creator.publicAddress}
                webappUri={post.creator.webappUri}
                src={post.creator.avatar?.url}
                username={post.creator.username}
              />
              <div className="flex flex-00auto items-center text-base-l font-semibold text-base800">
                <div className="line-clamp-1">{post.creator.username}</div>
                {!post.creator.artist && <VerifiedRainbow className="ml-1" />}
              </div>
              <div className="line-clamp-1 flex-1 font-base text-base-l text-neutral500">
                posted this song to the feed
              </div>
            </div>
          </ListContent>
        </Link>
      </div>
    </FeedListViewContainer>
  );
}
